//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import uiRouter from "angular-ui-router";

export const IS_SHOWROOM =
  (ENV_TAGS || []).indexOf("Showroom") >= 0; //webpack.DefinePlugin

//modules

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import appReleasesContainer from "servicestack/app-releases/app-releases-container";

//directives
// import parcelPicker from "servicestack/app-releases/parcel-picker/parcel-picker.directive";

//states
import states from "servicestack/app-releases/app-releases.states";

export const dependencies = [dropdown, collapse, tabs, uiRouter];

export const modules = {};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  appReleasesContainer,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states,
};
